/* r3tro chrome — theme behaviour (no dependencies) */
(function () {
  "use strict";

  var R3 = window.R3 || {};
  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  /* ---------- money ---------- */
  function formatMoney(cents) {
    var fmt = R3.moneyFormat || "${{amount}}";
    var n = (Number(cents) || 0) / 100;
    var withDelims = function (num, dec, thou, decSep) {
      var parts = num.toFixed(dec).split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return parts.length > 1 ? parts[0] + decSep + parts[1] : parts[0];
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case "amount_no_decimals": return withDelims(n, 0, ",", ".");
        case "amount_with_comma_separator": return withDelims(n, 2, ".", ",");
        case "amount_no_decimals_with_comma_separator": return withDelims(n, 0, ".", ",");
        case "amount_with_apostrophe_separator": return withDelims(n, 2, "'", ".");
        default: return withDelims(n, 2, ",", ".");
      }
    });
  }
  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  /* ---------- scroll loop (one listener for everything) ---------- */
  var scrollFns = [];
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      for (var i = 0; i < scrollFns.length; i++) scrollFns[i]();
    });
  }
  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", onScroll);

  function progressOf(el) {
    var r = el.getBoundingClientRect();
    var range = r.height - window.innerHeight;
    return range > 0 ? Math.min(1, Math.max(0, -r.top / range)) : 0;
  }

  /* ---------- pinned scenes: --p and data-step ---------- */
  $$("[data-scene]").forEach(function (el) {
    var steps = parseInt(el.getAttribute("data-steps") || "0", 10);
    scrollFns.push(function () {
      var p = progressOf(el);
      el.style.setProperty("--p", p.toFixed(4));
      if (steps) {
        var s = String(Math.min(steps - 1, Math.floor(p * steps)));
        if (el.getAttribute("data-step") !== s) el.setAttribute("data-step", s);
      }
    });
  });

  /* ---------- sideways gallery track ---------- */
  $$("[data-htrack]").forEach(function (outer) {
    var track = $("[data-htrack-track]", outer);
    if (!track) return;
    var mq = window.matchMedia("(min-width: 761px) and (prefers-reduced-motion: no-preference)");
    var dist = 0;
    function measure() {
      if (!mq.matches) {
        outer.style.height = "";
        track.style.transform = "";
        outer.classList.remove("is-live");
        return;
      }
      outer.classList.add("is-live");
      dist = Math.max(0, track.scrollWidth - document.documentElement.clientWidth);
      outer.style.height = (window.innerHeight + dist) + "px";
      update();
    }
    function update() {
      if (!mq.matches) return;
      var p = progressOf(outer);
      track.style.transform = "translate3d(" + (-p * dist).toFixed(1) + "px,0,0)";
      outer.style.setProperty("--p", p.toFixed(4));
    }
    scrollFns.push(update);
    window.addEventListener("resize", measure);
    if (mq.addEventListener) mq.addEventListener("change", measure);
    if ("ResizeObserver" in window) new ResizeObserver(measure).observe(track);
    $$("img", track).forEach(function (img) { if (!img.complete) img.addEventListener("load", measure, { once: true }); });
    measure();
  });

  /* ---------- reveal on scroll ---------- */
  (function () {
    var els = $$("[data-reveal]");
    if (!("IntersectionObserver" in window)) { els.forEach(function (e) { e.classList.add("is-in"); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add("is-in"); io.unobserve(en.target); }
      });
    }, { rootMargin: "0px 0px -6% 0px", threshold: 0.05 });
    els.forEach(function (e) { io.observe(e); });
  })();

  /* ---------- header + progress bar ---------- */
  (function () {
    var header = $("[data-header]");
    var bar = $("[data-scroll-bar]");
    scrollFns.push(function () {
      var max = document.documentElement.scrollHeight - window.innerHeight;
      if (bar) bar.style.transform = "scaleX(" + (max > 0 ? window.scrollY / max : 0).toFixed(4) + ")";
      if (header) header.classList.toggle("scrolled", window.scrollY > 24);
    });
  })();

  /* ---------- intro (once per visit) ---------- */
  (function () {
    var intro = document.getElementById("intro");
    if (!intro) return;
    var seen = false;
    try { seen = sessionStorage.getItem("r3_intro") === "1"; } catch (e) {}
    if (seen || (window.Shopify && window.Shopify.designMode)) { intro.remove(); return; }
    try { sessionStorage.setItem("r3_intro", "1"); } catch (e) {}
    intro.hidden = false;
    var done = false;
    function dismiss() {
      if (done) return;
      done = true;
      intro.classList.add("done");
      setTimeout(function () { intro.remove(); }, 620);
    }
    intro.addEventListener("click", dismiss);
    setTimeout(dismiss, reduceMotion ? 900 : 2900);
  })();

  /* =========================================================
     CART (Shopify AJAX Cart API)
     ========================================================= */
  var drawer = document.getElementById("CartDrawer");
  var scrim = $("[data-cart-scrim]");
  var cartState = null;

  function openCart() {
    if (!drawer) return;
    drawer.classList.add("open");
    drawer.setAttribute("aria-hidden", "false");
    if (scrim) scrim.classList.add("open");
  }
  function closeCart() {
    if (!drawer) return;
    drawer.classList.remove("open");
    drawer.setAttribute("aria-hidden", "true");
    if (scrim) scrim.classList.remove("open");
  }

  function renderCart(cart) {
    cartState = cart;
    $$("[data-cart-count]").forEach(function (el) { el.textContent = cart.item_count; });
    var sub = $("[data-cart-subtotal]");
    if (sub) sub.textContent = formatMoney(cart.total_price);
    var checkoutBtn = $("[data-cart-checkout]");
    if (checkoutBtn) checkoutBtn.disabled = cart.item_count === 0;
    var list = $("[data-cart-items]");
    if (!list) return;
    if (!cart.items.length) {
      list.innerHTML = '<div class="empty"><p>Empty for now. Go find your wrist candy.</p>' +
        '<a class="btn btn-glass" href="/#buy" data-cart-close>Shop the watches</a></div>';
      return;
    }
    list.innerHTML = cart.items.map(function (item) {
      var img = item.image ? item.image + (item.image.indexOf("?") > -1 ? "&" : "?") + "width=160" : "";
      var variant = item.product_has_only_default_variant ? "" : esc(item.variant_title) + " · ";
      return '<div class="line" data-key="' + esc(item.key) + '">' +
        '<a href="' + esc(item.url) + '" class="mini has-img">' + (img ? '<img src="' + esc(img) + '" alt="" width="60" height="60">' : "") + "</a>" +
        '<div class="info"><h4>' + esc(item.product_title) + "</h4>" +
        '<div class="p">' + variant + formatMoney(item.final_price) + "</div>" +
        '<button type="button" class="line-remove" data-qty="0">Remove</button></div>' +
        '<div class="qty">' +
          '<button type="button" data-qty="' + (item.quantity - 1) + '" aria-label="Decrease">−</button>' +
          "<span>" + item.quantity + "</span>" +
          '<button type="button" data-qty="' + (item.quantity + 1) + '" aria-label="Increase">+</button>' +
        "</div></div>";
    }).join("");
  }

  function setNote(msg) {
    var note = $("[data-cart-note]");
    if (note) note.textContent = msg || "Taxes and shipping calculated at checkout.";
  }

  function fetchCart() {
    return fetch((R3.routes && R3.routes.cart) || "/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; });
  }

  function changeLine(key, qty) {
    return fetch((R3.routes && R3.routes.cartChange) || "/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity: Math.max(0, qty) })
    }).then(function (r) { return r.json(); }).then(function (cart) {
      if (cart && cart.items) { renderCart(cart); setNote(); }
      else { setNote((cart && (cart.description || cart.message)) || "Couldn't update the cart."); fetchCart(); }
    });
  }

  function addToCart(variantId, qty) {
    return fetch((R3.routes && R3.routes.cartAdd) || "/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty || 1 }] })
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw new Error(data.description || data.message || "Couldn't add to cart.");
        return data;
      });
    });
  }

  document.addEventListener("click", function (e) {
    var openBtn = e.target.closest("[data-cart-open]");
    if (openBtn && drawer) {
      e.preventDefault();
      fetchCart().then(openCart, openCart);
      return;
    }
    if (e.target.closest("[data-cart-close]") || e.target === scrim) {
      closeCart();
      return;
    }
    var qtyBtn = e.target.closest("[data-qty]");
    if (qtyBtn && drawer && drawer.contains(qtyBtn)) {
      var line = qtyBtn.closest("[data-key]");
      if (line) changeLine(line.getAttribute("data-key"), parseInt(qtyBtn.getAttribute("data-qty"), 10));
    }
  });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeCart(); });

  // Every Shopify product form on the page adds via AJAX and opens the drawer.
  document.addEventListener("submit", function (e) {
    var form = e.target;
    if (!form.classList || !form.classList.contains("js-add-form") || !drawer) return;
    e.preventDefault();
    var idInput = form.querySelector('[name="id"]');
    var btn = form.querySelector('[type="submit"]');
    var err = form.parentNode && form.parentNode.querySelector("[data-form-error]");
    if (!idInput) return;
    if (btn) { btn.disabled = true; btn.classList.add("is-busy"); }
    if (err) err.hidden = true;
    addToCart(idInput.value, 1)
      .then(function () {
        if (btn) {
          var label = btn.textContent;
          btn.classList.add("added");
          btn.textContent = "Added ✓";
          setTimeout(function () { btn.classList.remove("added"); btn.textContent = label; }, 900);
        }
        return fetchCart();
      })
      .then(openCart)
      .catch(function (ex) {
        if (err) { err.textContent = ex.message; err.hidden = false; }
        else { setNote(ex.message); fetchCart().then(openCart); }
      })
      .then(function () { if (btn) { btn.disabled = false; btn.classList.remove("is-busy"); } });
  });

  /* =========================================================
     GALLERY (scroll-snap, follows selected colour)
     ========================================================= */
  function initGallery(gal) {
    var track = $("[data-gal-track]", gal);
    if (!track) return null;
    var count = $("[data-gal-count]", gal);
    var prev = $("[data-gal-prev]", gal);
    var next = $("[data-gal-next]", gal);
    var thumbs = $$(".gal-thumb", gal);

    function visibleSlides() {
      var slides = $$(".gal-slide", track).filter(function (s) { return !s.classList.contains("is-other"); });
      slides.sort(function (a, b) { return (a.classList.contains("is-own") ? 0 : 1) - (b.classList.contains("is-own") ? 0 : 1); });
      return slides;
    }
    function current() {
      return Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
    }
    function sync() {
      var vis = visibleSlides();
      var i = Math.min(current(), vis.length - 1);
      if (count) count.textContent = vis.length > 1 ? (i + 1) + " / " + vis.length : "";
      if (prev) { prev.disabled = i <= 0; prev.hidden = vis.length < 2; }
      if (next) { next.disabled = i >= vis.length - 1; next.hidden = vis.length < 2; }
      var activeId = vis[i] && vis[i].getAttribute("data-media-id");
      thumbs.forEach(function (t) { t.classList.toggle("active", t.getAttribute("data-media-id") === activeId); });
    }
    function go(i) {
      track.scrollTo({ left: i * track.clientWidth, behavior: reduceMotion ? "auto" : "smooth" });
    }
    function setOwner(variantId) {
      var id = String(variantId);
      var own = [], shared = [], other = [];
      $$(".gal-slide", track).forEach(function (s) {
        var owner = s.getAttribute("data-owner");
        s.classList.remove("is-own", "is-other", "is-shared");
        var st = owner === "shared" ? "is-shared" : owner === id ? "is-own" : "is-other";
        s.classList.add(st);
        (st === "is-own" ? own : st === "is-shared" ? shared : other).push(s);
      });
      // The colour's main photo always leads.
      own.sort(function (a, b) { return (b.hasAttribute("data-lead") ? 1 : 0) - (a.hasAttribute("data-lead") ? 1 : 0); });
      // Physically reorder so scroll-snap starts on the picked colour's lead photo.
      own.concat(shared, other).forEach(function (s) { track.appendChild(s); });
      var lead = own[0] && $("img", own[0]);
      if (lead) lead.loading = "eager";
      var states = {};
      $$(".gal-slide", track).forEach(function (s) { states[s.getAttribute("data-media-id")] = s.className; });
      thumbs.forEach(function (t) {
        var st = states[t.getAttribute("data-media-id")] || "";
        t.classList.toggle("is-hidden", st.indexOf("is-other") !== -1);
        t.classList.toggle("is-own", st.indexOf("is-own") !== -1);
      });
      track.scrollTo({ left: 0, behavior: "auto" });
      sync();
    }
    track.addEventListener("scroll", function () { requestAnimationFrame(sync); }, { passive: true });
    if (prev) prev.addEventListener("click", function () { go(Math.max(0, current() - 1)); });
    if (next) next.addEventListener("click", function () { go(current() + 1); });
    thumbs.forEach(function (t) {
      t.addEventListener("click", function () {
        var vis = visibleSlides();
        for (var i = 0; i < vis.length; i++) {
          if (vis[i].getAttribute("data-media-id") === t.getAttribute("data-media-id")) { go(i); break; }
        }
      });
    });
    // initial thumb state from server-rendered classes
    var own = $(".gal-slide.is-own", track);
    setOwner(own ? own.getAttribute("data-owner") : "__none__");
    return { setOwner: setOwner };
  }

  /* =========================================================
     PRODUCT FORMS (colour picker ↔ price ↔ gallery ↔ URL)
     ========================================================= */
  $$("[data-product-root]").forEach(function (root) {
    var form = $("[data-product-form]", root);
    if (!form) return;
    var variants = [];
    try { variants = JSON.parse($("[data-variants]", form).textContent); } catch (e) {}
    var gal = $("[data-gallery]", root);
    var gallery = gal ? initGallery(gal) : null;
    var idInput = $("[data-variant-id]", form);
    var addBtn = $("[data-add-button]", form);
    var nameEl = $("[data-variant-name]", form);
    var compareEl = $("[data-compare]", form);
    var isProductPage = !!$("#buy-anchor", root);
    var sticky = $("[data-sticky-buy]", root);

    function swatchColor(v) {
      var label = $$(".swatch", form).filter(function (l) { return $("input", l).value === String(v.id); })[0];
      var dot = label && $(".sw-dot", label);
      return dot ? dot.style.getPropertyValue("--sw") : "";
    }

    function select(v, fromUser) {
      if (!v) return;
      if (idInput) idInput.value = v.id;
      $$("[data-price]", root).forEach(function (el) { el.textContent = formatMoney(v.price); });
      if (compareEl) {
        compareEl.hidden = !(v.compare > v.price);
        compareEl.textContent = v.compare > v.price ? formatMoney(v.compare) : "";
      }
      if (nameEl) nameEl.textContent = v.title;
      $$(".swatch", form).forEach(function (l) {
        var on = $("input", l).value === String(v.id);
        l.classList.toggle("on", on);
        $("input", l).checked = on;
      });
      [addBtn, sticky && $("[data-sticky-add]", sticky)].forEach(function (b) {
        if (!b) return;
        b.disabled = !v.available;
        b.textContent = v.available ? "Add to cart" : "Sold out";
      });
      if (sticky) {
        var sv = $("[data-sticky-variant]", sticky);
        if (sv && variants.length > 1) sv.textContent = v.title + " · ";
        var dot = $("[data-sticky-dot]", sticky);
        if (dot) dot.style.setProperty("--sw", swatchColor(v));
      }
      if (gallery) gallery.setOwner(v.id);
      if (fromUser && isProductPage && window.history && history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set("variant", v.id);
        history.replaceState(null, "", url.toString());
      }
    }

    form.addEventListener("change", function (e) {
      if (e.target && e.target.type === "radio") {
        var v = variants.filter(function (x) { return String(x.id) === e.target.value; })[0];
        select(v, true);
      }
    });

    // sticky add bar (product page)
    if (sticky) {
      var stickyAdd = $("[data-sticky-add]", sticky);
      if (stickyAdd) stickyAdd.addEventListener("click", function () {
        var f = $(".js-add-form", form);
        if (f && f.requestSubmit) f.requestSubmit();
        else if (f) f.dispatchEvent(new Event("submit", { cancelable: true, bubbles: true }));
      });
      var anchor = document.getElementById("buy-anchor");
      if (anchor && "IntersectionObserver" in window) {
        new IntersectionObserver(function (entries) {
          var en = entries[0];
          var show = !en.isIntersecting && en.boundingClientRect.top < 0;
          sticky.classList.toggle("show", show);
          sticky.setAttribute("aria-hidden", show ? "false" : "true");
        }).observe(anchor);
      }
      var initial = variants.filter(function (x) { return idInput && String(x.id) === idInput.value; })[0];
      if (initial) { var d = $("[data-sticky-dot]", sticky); if (d) d.style.setProperty("--sw", swatchColor(initial)); }
    }
  });

  /* ---------- first paint ---------- */
  onScroll();
  window.addEventListener("load", onScroll);
})();
